import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";
import type { DrawnItineraryGeometry } from "../types";

/** Ephemeral slice holding polylines drawn for the active itinerary. */
export const drawnItineraryGeometrySlice = defineEphemeralSlice<DrawnItineraryGeometry | null>( {
    "key":     "drawnItineraryGeometry",
    "default": () => null,
} );
